import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown, Modal } from 'react-bootstrap'
import DatePicker from 'react-datepicker'

import FilterPagination from 'pages/parts/FilterPagination'
import { GET, httpOk } from 'helpers/api'
import { formatDate, formatMoney, chequeDates, getCurrentChequeDate, checkFilter } from 'helpers/helpers'

function ReturnsReport() {
	const { t } = useTranslation()
	const date = new Date()

	const initialFilter = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date:   formatDate(new Date(), 'yyyy-MM-dd'),
		search:     '',
	}

	const [data, setData]                         = useState({ data: [], total: 0, total_amount: 0 })
	const [filterData, setFilterData]             = useState({ ...initialFilter })
	const [filterDataExist, setFilterDataExist]   = useState(false)
	const [dropdownIsOpen, setDropdownIsOpen]     = useState(false)
	const [selectedReturn, setSelectedReturn]     = useState(null)
	const [pagination, setPagination]             = useState({ url: '/report/returns', response: null })

	async function getData() {
		setFilterDataExist(checkFilter(filterData, initialFilter))
		const response = await GET('/report/returns', filterData, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, response: response.data })
			if (dropdownIsOpen) setDropdownIsOpen(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, page, size })
	}

	function resetFilter() {
		setFilterData({ ...initialFilter })
	}

	async function selectChequeDates(option) {
		const result = getCurrentChequeDate(option.id)
		setFilterData({ ...filterData, ...result, dateType: option.id })
	}

	useEffect(() => {
		getData()
	}, [filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('returns_report')} [{data.total}]
				</h4>
				<div className="vertical-center">
					<span className="text-muted me-2">{t('total')}:</span>
					<span className="text-danger fw-bold fs-5">{formatMoney(data.total_amount)}</span>
					{/* Jurnal (ADR-011) tannarxni ham saqlaydi — backend hisoblab berardi,
					    lekin ekranda umuman chizilmasdi (o'lik ish). */}
					{Number(data.total_profit) !== 0 &&
						<span className="text-muted ms-3" style={{ fontSize: 13 }}>
							{t('lost_profit')}: <b className="text-danger">{formatMoney(data.total_profit)}</b>
						</span>
					}
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex justify-content-between mb-3">
						<div className="d-flex gap-2">
						<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
							<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
								{t('filter')}
							</Dropdown.Toggle>

							<Dropdown.Menu className="dropdown-filter">
								<div className="row">
									<div className="form-group col-md-4">
										<label>{t('period')}</label>
										<select className="form-select"
											onChange={(e) => selectChequeDates({ id: e.target.value })}
											value={filterData.dateType || ''}>
											<option value="">{t('select')}</option>
											{chequeDates.map(opt => (
												<option key={opt.id} value={opt.id}>{opt.name}</option>
											))}
										</select>
									</div>
									<div className="form-group col-md-4">
										<label className="invisible">.</label>
										<div className="calendar-input">
											<DatePicker className="form-control" dateFormat="dd.MM.yyyy"
												selected={filterData.start_date ? new Date(filterData.start_date) : ''}
												onChange={(d) => setFilterData({ ...filterData, start_date: formatDate(d, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
									<div className="form-group col-md-4">
										<label className="invisible">.</label>
										<div className="calendar-input">
											<DatePicker className="form-control" dateFormat="dd.MM.yyyy"
												selected={filterData.end_date ? new Date(filterData.end_date) : ''}
												onChange={(d) => setFilterData({ ...filterData, end_date: formatDate(d, 'yyyy-MM-dd') })} />
											<i className="uil uil-calendar-alt"></i>
										</div>
									</div>
								</div>

								<div className="row mt-3">
									<div className="form-group col-md-12">
										<label>{t('search')}</label>
										<input type="text" className="form-control"
											value={filterData.search}
											onChange={(e) => setFilterData({ ...filterData, search: e.target.value })}
											placeholder={`${t('cheque')} №, ${t('client')}, ${t('cashier')}`} />
									</div>
								</div>

								<div className="row mt-3">
									<div className="col-md-12 d-flex justify-content-end gap-2">
										<button className="btn btn-secondary" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
										<button className="btn btn-primary" onClick={getData}>{t('apply')}</button>
									</div>
								</div>
							</Dropdown.Menu>
						</Dropdown>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong><br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date && <span>{formatDate(filterData.start_date)}</span>}
										{filterData.start_date && filterData.end_date && <span> | </span>}
										{filterData.end_date && <span>{formatDate(filterData.end_date)}</span>}
									</span>
								}
								{filterData.search && <span className="me-2"><b>{t('search')}: </b>{filterData.search}</span>}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ minWidth: '40px' }}>#</th>
									<th style={{ minWidth: '70px' }}>{t('cheque')} №</th>
									<th style={{ minWidth: '120px' }}>{t('client')}</th>
									<th style={{ minWidth: '130px' }}>{t('return_date')}</th>
									<th style={{ minWidth: '110px' }}>{t('processed_by')}</th>
									<th style={{ minWidth: '150px' }}>{t('return_reason')}</th>
									<th style={{ minWidth: '100px' }} className="text-end">{t('return_amount')}</th>
								<th style={{ minWidth: '100px' }} className="text-end">{t('cost_price')}</th>
								<th style={{ minWidth: '100px' }} className="text-end">{t('profit')}</th>
									<th style={{ minWidth: '40px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index} className="tr-middle">
										<td>{index + 1 + (filterData.page ?? 0) * (filterData.size ?? 20)}</td>
										<td className="fw-bold text-primary">#{item.cheque_id}</td>
										<td>{item.client_name || '—'}</td>
										<td>{item.return_datetime ? formatDate(item.return_datetime, 'dd.MM.yyyy HH:mm') : '—'}</td>
										<td>{item.processed_by || '—'}</td>
										{/* Sabab 2026-08-14 dan yozila boshladi. Undan oldingi qatorlarda
											bu yerda ADR-011 ko'chirmasining TEXNIK izohi turadi
											(«tarixdan ko'chirildi …») — uni foydalanuvchiga ko'rsatish
											shovqin, shuning uchun chiziqcha chiqaramiz. */}
										<td className="text-muted"
											title={item.return_reason || ''}>
											{item.return_reason && !item.return_reason.startsWith('tarixdan')
												? item.return_reason
												: '—'}
										</td>
										<td className="text-end fw-bold text-danger">{formatMoney(item.total_returned_amount)}</td>
										<td className="text-end text-muted">{formatMoney(item.total_returned_cost)}</td>
										<td className="text-end text-danger">{formatMoney(item.total_returned_profit)}</td>
										<td>
											<button className="btn btn-sm btn-outline-secondary"
												onClick={() => setSelectedReturn(item)}
												title={t('products')}>
												<i className="uil uil-eye"></i>
											</button>
										</td>
									</tr>
								))}

								{data?.data?.length === 0 &&
									<tr>
										{/* 10 = 9 ta eski ustun + «Qaytarish sababi» (2026-08-14) */}
										<td colSpan="10" className="text-center text-muted py-4">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
							{data?.data?.length > 0 &&
								<tfoot className="table-secondary fw-bold">
									<tr>
										{/* 6 = #, chek, mijoz, sana, kim qaytardi, SABAB — summalar
											ustunlari bilan bir qatorda tursin (2026-08-14 da 5 dan oshdi) */}
										<td colSpan="6" className="text-end">{t('total')}</td>
										<td className="text-end text-danger">{formatMoney(data.total_amount)}</td>
										<td className="text-end text-muted">{formatMoney(data.total_cost)}</td>
										<td className="text-end text-danger">{formatMoney(data.total_profit)}</td>
										<td></td>
									</tr>
								</tfoot>
							}
						</table>
					</div>

					{pagination.response &&
						<FilterPagination pagination={pagination} paginate={paginate} />
					}
				</div>
			</div>

			{/* Mahsulotlar modali */}
			<Modal show={!!selectedReturn} animation={false} centered size="lg"
				onHide={() => setSelectedReturn(null)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('return')} — {t('cheque')} #{selectedReturn?.cheque_id}
						{selectedReturn?.client_name &&
							<span className="text-muted ms-2 fz-14">— {selectedReturn.client_name}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="row mb-3">
						<div className="col-6">
							<div className="d-between">
								<span className="text-muted">{t('client')}</span>
								<span>{selectedReturn?.client_name || '—'}</span>
							</div>
							<div className="d-between">
								<span className="text-muted">{t('phone')}</span>
								<span>{selectedReturn?.client_phone || '—'}</span>
							</div>
						</div>
						<div className="col-6">
							<div className="d-between">
								<span className="text-muted">{t('processed_by')}</span>
								<span className="fw-bold">{selectedReturn?.processed_by || '—'}</span>
							</div>
							<div className="d-between">
								<span className="text-muted">{t('return_date')}</span>
								<span>{selectedReturn?.return_datetime
									? formatDate(selectedReturn.return_datetime, 'dd.MM.yyyy HH:mm')
									: '—'}
								</span>
							</div>
						</div>
					</div>

					<table className="table table-bordered mb-0">
						<thead>
							<tr>
								<th>#</th>
								<th>{t('product_name')}</th>
								<th className="text-end">{t('quantity')}</th>
								<th className="text-end">{t('amount')}</th>
							</tr>
						</thead>
						<tbody>
							{selectedReturn?.products?.map((p, i) => (
								<tr key={i}>
									<td>{i + 1}</td>
									<td>{p.product_name}</td>
									<td className="text-end">{formatMoney(p.quantity, 3)}</td>
									<td className="text-end fw-bold">{formatMoney(p.total_amount)}</td>
								</tr>
							))}
						</tbody>
						<tfoot className="table-secondary fw-bold">
							<tr>
								<td colSpan="3" className="text-end">{t('total')}</td>
								<td className="text-end text-danger">{formatMoney(selectedReturn?.total_returned_amount)}</td>
							</tr>
						</tfoot>
					</table>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default ReturnsReport
